export default "__VITE_ASSET__oJfLo4W0__"